<template>
  <!-- The visitor's top bar on the marketing pages (meta.marketing): the dark bar as fogged glass, floating over the
       page, which scrolls under it. Signed-in users keep the solid TopBar everywhere. Left: the logo, a divider, then
       from md up the landing's section links, and Pricing; right: Log in and Start free (the only sign-up between the
       hero and the end of the landing). A phone keeps Pricing, Log in and Start free (no menu for in-page links). -->
  <header class="pointer-events-none absolute inset-x-0 top-0 z-30 px-3 pt-2 sm:px-5 sm:pt-3">
    <nav
      class="pointer-events-auto rounded-2xl border border-white/10 bg-dark-nav/75 backdrop-blur-xl backdrop-saturate-150 transition-shadow duration-300"
      :class="scrolled ? 'shadow-[0_8px_30px_rgb(30_41_59/0.25)]' : 'shadow-[0_2px_12px_rgb(30_41_59/0.12)]'"
      aria-label="Main"
    >
      <div class="flex h-14 items-center justify-between gap-2 pl-3 pr-2 sm:h-16 sm:gap-3 sm:pl-8 sm:pr-8">
        <div class="flex min-w-0 items-center gap-1 sm:gap-4">
          <router-link to="/" aria-label="Gettourly home" class="flex shrink-0 items-center">
            <img src="/logo-big-clear.svg" alt="Gettourly" class="block h-9 sm:h-12" />
          </router-link>
          <div aria-hidden="true" class="hidden h-6 w-px bg-white/20 sm:block" />
          <div class="flex items-center gap-1">
            <router-link
              v-for="s in LANDING_SECTIONS"
              :key="s.id"
              :to="{ path: '/', hash: `#${s.id}` }"
              :class="[LINK, 'hidden text-white/90 hover:bg-white/10 md:block']"
              @click="onSection($event, s.id)"
            >{{ s.label }}</router-link>
            <router-link to="/pricing" :class="[LINK, linkState('/pricing')]">Pricing</router-link>
          </div>
        </div>

        <div class="flex shrink-0 items-center gap-1 sm:gap-2">
          <!-- On the login page itself it offers the other way in. -->
          <router-link
            :to="route.path === '/login' ? '/register' : '/login'"
            class="rounded-lg px-2 py-1.5 text-sm font-medium text-white transition-colors hover:bg-white/10 sm:border sm:border-white/40 sm:px-4"
          >{{ route.path === '/login' ? 'Sign up' : 'Log in' }}</router-link>
          <router-link
            v-if="!AUTH_PATHS.includes(route.path)"
            to="/register"
            class="inline-flex h-9 items-center rounded-lg bg-primary px-3 text-sm font-semibold text-white transition-colors hover:bg-primary-dark sm:px-4"
          >Start free</router-link>
        </div>
      </div>
    </nav>
  </header>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import { LANDING_SECTIONS, scrollToSection } from '@/components/landing/sections'

defineProps<{ scrolled: boolean }>()

/** The sign-in pages: Start free would only point at the page itself or its twin. */
const AUTH_PATHS = ['/login', '/register']
const LINK = 'rounded-lg px-2 py-1.5 text-sm font-medium transition-colors sm:px-3'

const route = useRoute()

const linkState = (path: string) => (route.path === path ? 'bg-white/15 text-white' : 'text-white/90 hover:bg-white/10')

/** On the landing itself the section is already there: scroll to it (a repeat click works too). */
function onSection(e: MouseEvent, id: string) {
  if (route.path === '/' && scrollToSection(id)) e.preventDefault()
}
</script>
